
export class widgetStatistics {

  static sendPresentationStatisticsEvent(tabName: string, isWidgetPresented: boolean) {
      const label = [
        'tab:' + tabName,
        'visible:' + isWidgetPresented
      ].join('###');

      return this.__trackEvent('show', label);
  }

  static sendRedirectionLearnMoreStatisticsEvent( tabName: string, clickType: string, searchResultPosition: number, faqId: string, redirectionUrl: string) {
      const label = [
        'linkType:learnMore',
        'tab:' + tabName,
        'clickType:' + clickType, //right, left, keyboard
        'position:' + searchResultPosition,
        'faqId:' + faqId,
        redirectionUrl ? 'openUrl:' + redirectionUrl : ''
      ].join('###');

      return this.__trackEvent('click', label);
  }

  static sendRedirectionSeeAllStatisticsEvent( tabName: string, clickType: string, redirectionUrl: string) {
      const label = [
        'linkType:seeAll',
        'tab:' + tabName,
        'clickType:' + clickType, //right, left, keyboard
        redirectionUrl ? 'openUrl:' + redirectionUrl : ''
      ].join('###');

      return this.__trackEvent('click', label);
  }

  static sendUnfoldStatisticsEvent(tabName:string, searchResultPosition: number, faqId: string, showHideAction: boolean) {
      const label = [
        'tab:' + tabName,
        'position:' + searchResultPosition,
        'faqId:' + faqId,
        'show:' + showHideAction
      ].join('###');

      return this.__trackEvent('unfold', label);
  }


  private static __trackEvent(action, label) {
      return {
        category: 'widget-faq',
        action: action,
        label: label
      };
  }
}
